import { DELETE } from "../../helper/xbi4RestFunctions";

const deleteOrgProjects = async (orgId: any, projectId: any) => {
  const path = `/orgs/${orgId}/projects/${projectId}`;
  return await DELETE(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching modules > ", err);
      return err;
    });
};

export default deleteOrgProjects;
